import { render, staticRenderFns } from "./WidgetMasterTab.vue?vue&type=template&id=ccb36aec&scoped=true&"
import script from "./WidgetMasterTab.vue?vue&type=script&lang=js&"
export * from "./WidgetMasterTab.vue?vue&type=script&lang=js&"
import style0 from "./WidgetMasterTab.vue?vue&type=style&index=0&id=ccb36aec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb36aec",
  null
  
)

export default component.exports